import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Calendar from 'hydrateio-react-calendar-pane'
import moment from 'moment'

import { Icon } from '../../../../shared/tr-icons'
import {
  DateRangeWrapper,
  DateRangeOuter,
  DateRangeCalendar,
  TodayLink,
  DateRangeLabel,
  DateRangeDescription,
  ErrorDivWrapper
} from '../StyledComponents'

import Breakout from '../../../breakout/Breakout'

export default class DateRangeComponent extends Component {
  constructor(props) {
    super(props)

    // Devnote: set position to be 'below' here to switch on window location sensitive positioning
    this.state = {
      toShow: false,
      fromShow: false,
      fromPosition: 'below',
      toposition: 'below',
      fromDateClicked: 'false',
      date: {
        from: this.props.fromDate
          ? this.getMomentDate(this.props.fromDate, true).isValid()
            ? moment(this.props.fromDate, this.props.dateFormat ? this.props.dateFormat.toUpperCase() : 'DD/MM/YYYY').format(this.props.dateFormat ? this.props.dateFormat.toUpperCase() : 'DD/MM/YYYY')
            : this.props.fromDate
          : '',
        to: this.props.toDate
          ? this.getMomentDate(this.props.toDate, true).isValid()
            ? moment(this.props.toDate, this.props.dateFormat ? this.props.dateFormat.toUpperCase() : 'DD/MM/YYYY').format(this.props.dateFormat ? this.props.dateFormat.toUpperCase() : 'DD/MM/YYYY')
            : this.props.toDate
          : ''
      },
      errors: {},
      validFromError: false,
      validToError: false,
      dateType: '' // it's the current selected type of date - either to or from
    }
    this.onSelect = this.onSelect.bind(this)
    this.selectToday = this.selectToday.bind(this)
    this.wrapperEl = null
  }

  onRefWrapper = el => {
    this.wrapperEl = el
  }

  componentWillReceiveProps(newProps) {
    const { dateFormat } = this.props

    if (newProps.fromDate === null && newProps.toDate === null) {
      this.initialiseErrors()
    }

    let errorResponse = {}

    if (newProps.toDate) {
      if (this.getMomentDate(newProps.toDate, true).isValid()) {
        errorResponse = this.validateErrorMessage('to', newProps.toDate)
      } else {
        errorResponse.message = newProps.i18n.invalid_to_date
        errorResponse.validFromError = false
        errorResponse.validToError = true
      }
    }
    if (newProps.fromDate) {
      if (this.getMomentDate(newProps.fromDate, true).isValid()) {
        errorResponse = this.validateErrorMessage('from', newProps.fromDate, newProps.toDate)
      } else {
        errorResponse.message = this.props.i18n.invalid_from_date
        errorResponse.validFromError = true
        errorResponse.validToError = false
      }
    }

    this.setState({
      date: {
        from: newProps.fromDate
          ? this.getMomentDate(newProps.fromDate, true).isValid()
            ? moment(newProps.fromDate, dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY').format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')
            : newProps.fromDate
          : '',
        to: newProps.toDate
          ? this.getMomentDate(newProps.toDate, true).isValid()
            ? moment(newProps.toDate, dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY').format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')
            : newProps.toDate
          : ''
      },
      errors: errorResponse,
      validFromError: errorResponse.validFromError,
      validToError: errorResponse.validToError
    })
  }

  selectToday = event => {
    this.onSelect(moment().startOf('day'))
  }

  onSelect(date) {
    const {
      dateFormat,
      dateRangeFromCallBack,
      dateRangeToCallBack,
      handleFromDateChange,
      handleToDateChange
    } = this.props

    const selectedDate = this.getMomentDate(date)
    const errors = {}
    const state = this.state

    let errorResponse = {}

    if (state.dateType === 'to') {
      errorResponse = this.validateErrorMessage('to', date)
    }

    if (state.dateType === 'from') {
      errorResponse = this.validateErrorMessage('from', date)
    }

    errors.message = errorResponse.message
    state.errors = errors
    state.validToError = errorResponse.validToError
    state.validFromError = errorResponse.validFromError

    if (errorResponse.message === null) {
      state.errors = {}
      state.validFromError = false
      state.validToError = false
      state.date[state.dateType] = selectedDate.format(
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
      )
      state.show = false
      state.toShow = false
      state.fromShow = false

      this.setState(state)

      if (state.dateType === 'to' && state.date.to !== '') {
        if (
          dateRangeToCallBack &&
          window.TR_pageFunctions[dateRangeToCallBack]
        ) {
          window.TR_pageFunctions[dateRangeToCallBack](
            date.toDate(),
            this.getMomentDate(state.date.to).toDate()
          )
        }

        if (handleToDateChange) {
          let from = null

          if (this.state.date.from) {
            from = this.getMomentDate(state.date.from).toDate()
          }
          const to = this.getMomentDate(date).toDate()

          handleToDateChange(to, from)
        }
      }

      if (state.dateType === 'from' && state.date.from !== '') {
        if (
          dateRangeFromCallBack &&
          window.TR_pageFunctions[dateRangeFromCallBack]
        ) {
          window.TR_pageFunctions[dateRangeFromCallBack](
            date.toDate(),
            this.getMomentDate(state.date.from).toDate()
          )
        }

        if (handleFromDateChange) {
          let to = null

          if (this.state.date.to) {
            to = this.getMomentDate(state.date.to).toDate()
          }
          const from = this.getMomentDate(date).toDate()

          handleFromDateChange(from, to)
        }

        this.toInput.focus()
      }
    } else {
      state.show = false
      state.toShow = false
      state.fromShow = false
      state.date[state.dateType] = selectedDate.format(
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
      )
      state.errors = errors

      this.setState(state)

      if (this.state.dateType === 'to' && this.state.date.to !== '') {
        if (handleToDateChange) {
          handleToDateChange(date, this.state.date.from, this.state.errors)
        }
      }

      if (state.dateType === 'from' && state.date.from !== '') {
        if (handleFromDateChange) {
          handleFromDateChange(date, this.state.date.to, this.state.errors)
        }
      }
    }
  }

  fromShow = event => {
    this.initialiseErrors(event)
    const state = this.state
    const offset = this.wrapperEl.getBoundingClientRect().bottom + this.wrapperEl.getBoundingClientRect().height

    if (
      offset >
      window.innerHeight - (this.wrapperEl.clientHeight + 200)
    ) {
      state.fromPosition = 'above'
    }

    state.fromShow = true
    state.fromDateClicked = true
    state.toShow = false
    state.fromShow = true
    state.dateType = 'from'

    this.setState(state)
  }

  toShow = event => {
    this.initialiseErrors(event)

    const state = this.state
    const offset =
      this.wrapperEl.getBoundingClientRect().bottom +
      this.wrapperEl.getBoundingClientRect().height

    if (
      offset >
      window.innerHeight - (this.wrapperEl.clientHeight + 200)
    ) {
      state.toPosition = 'above'
    }

    state.toShow = true
    state.fromDateClicked = false
    state.toShow = true
    state.fromShow = false
    state.dateType = 'to'
    this.setState(state)
  }

  setFromValue = event => {
    const state = this.state

    state.date.from = event.target.value
    this.setState(state)
  }


  initialiseErrors = event => {
    const state = this.state

    state.validToError = false
    state.validFromError = false
    state.errors = {}
    this.setState(state)
  }

  handleFromKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      this.validateFromEntry(evt)
    }
  }

  validateFromEntry = event => {
    const { dateFormat, dateRangeFromCallBack, handleFromDateChange } = this.props
    const errors = {}
    const state = this.state

    state.validFromError = false
    state.validToError = false

    const errorResponse = this.validateErrorMessage('from', event.target.value)

    errors.message = errorResponse.message
    state.errors = errors
    state.validToError = errorResponse.validToError
    state.validFromError = errorResponse.validFromError

    this.setState(state)

    if (errorResponse.message === null) {
      state.errors = {}
      state.validFromError = false
      state.validToError = false
      state.show = false
      state.toShow = false
      state.fromShow = false

      this.setState(state)

      if (
        dateRangeFromCallBack &&
        window.TR_pageFunctions[dateRangeFromCallBack]
      ) {
        window.TR_pageFunctions[dateRangeFromCallBack](
          this.state.date.from.toDate(),
          this.getMomentDate(state.date.from).toDate()
        )
      }

      if (handleFromDateChange) {
        let to = null

        if (this.state.date.to &&
          moment(
            this.state.date.to,
            dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY',
            true
          ).isValid()) {
          to = this.getMomentDate(state.date.to).toDate()
        }
        event.target.value.trim() !== ''
          ? handleFromDateChange(this.getMomentDate(event.target.value).toDate(), to)
          : handleFromDateChange(null, to)
      }
    } else if (handleFromDateChange) {
        event.target.value.trim() !== ''
          ? handleFromDateChange(event.target.value, this.state.date.to, this.state.errors)
          : handleFromDateChange(null, this.state.date.to, this.state.errors)
      }
  }

  setToValue = event => {
    const state = this.state

    state.date.to = event.target.value

    this.setState(state)
  }

  handleToKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      this.validateToEntry(evt)
    }
  }

  validateToEntry = event => {
    const { dateFormat, dateRangeToCallBack, handleToDateChange } = this.props
    const errors = {}
    const state = this.state

    state.validFromError = false
    state.validToError = false

    const errorResponse = this.validateErrorMessage('to', event.target.value)

    errors.message = errorResponse.message
    state.errors = errors
    state.validToError = errorResponse.validToError
    state.validFromError = errorResponse.validFromError

    this.setState(state)

    if (errorResponse.message === null) {
      state.errors = {}
      state.validFromError = false
      state.validToError = false
      state.show = false
      state.toShow = false
      state.fromShow = false

      this.setState(state)

      if (
        dateRangeToCallBack &&
        window.TR_pageFunctions[dateRangeToCallBack]
      ) {
        window.TR_pageFunctions[dateRangeToCallBack](
          this.state.date.to.toDate(),
          this.getMomentDate(state.date.to).toDate()
        )
      }

      if (handleToDateChange) {
        let from = null

        if (this.state.date.from &&
          moment(
            this.state.date.from,
            dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY',
            true
          ).isValid()) {
          from = this.getMomentDate(state.date.from).toDate()
        }

        event.target.value.trim() !== ''
          ? handleToDateChange(this.getMomentDate(event.target.value).toDate(), from)
          : handleToDateChange(null, from)
      }
    } else if (handleToDateChange) {
        event.target.value.trim() !== ''
          ? handleToDateChange(event.target.value, this.state.date.from, this.state.errors)
          : handleToDateChange(null, this.state.date.from, this.state.errors)
      }
  }

  close = () => {
    this.setState({
      dateType: '',
      fromShow: false,
      show: false,
      toShow: false
    })
  }

  positionCalendar() {
    const { fromDateClicked, fromPosition, toPosition } = this.state
    const style = {}

    if (fromPosition === 'above' || toPosition ==='above'){
      style.top = 'auto'
      style.bottom = fromDateClicked ? 0 : '-80px'
      style.transformOrigin = '50% 150%'
    }
    else{
      style.transformOrigin = '50% -75%'
    }
    
    return style
  }

  setLabel() {
    const { i18n } = this.props

    return (this.state.dateType === 'from') ? i18n.select_from_date : i18n.select_to_date
  }

  dayRenderer = ({ date, handleClick, disabled }) => {
    const { dateFormat } = this.props
    const {
      date: { from, to }
    } = this.state

    const classNames = ['Day-inner']
    const dateFmt = date.format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')

    if (from && from === dateFmt) {
      classNames.push('from')
    }

    if (to && to === dateFmt) {
      classNames.push('to')
    }

    if (this.state.toShow && this.state.date.from && dateFmt) {
      if (!this.props.preventFutureDates) {
        disabled = this.getMomentDate(this.state.date.from) > this.getMomentDate(dateFmt)
      } else {
        disabled = this.getMomentDate(this.state.date.from) > this.getMomentDate(dateFmt) ||
        this.getMomentDate(dateFmt) > moment()
      }
    }

    return (
      <button
        className={classNames.join(' ')}
        onClick={() => handleClick(date)}
        type='button'
        disabled={disabled}
      >
        {date.format('D')}
      </button>
    )
  }

  getMomentDate = (date, strictMode) => {
    const {
      dateFormat
    } = this.props

    if (strictMode) {
      return moment(
        date,
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY',
        true
      )
    }
      return moment(
        date,
        dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY'
      )

  }

  validateErrorMessage = (dateType, selectedDate, otherDate) => {
    const {
      preventFutureDates,
      i18n
    } = this.props

    let validToError = false
    let validFromError = false
    let message = null

    if (dateType === 'from') {
      if (
        preventFutureDates && this.state.date.to !== '' && this.getMomentDate(this.state.date.to).isAfter(moment())
      ) {
        message = i18n.invalid_to_future_date
        validToError = true
        validFromError = false
      }
      if (preventFutureDates && this.getMomentDate(selectedDate).isAfter(moment())) {
        message = i18n.invalid_from_future_date
        validFromError = true
        validToError = false
      }
      if (otherDate === undefined) {
        if (this.getMomentDate(selectedDate) > this.getMomentDate(this.state.date.to)) {
          message = i18n.invalid_date_range
          validToError = true
          validFromError = false
        }
      } else if (this.getMomentDate(selectedDate) > this.getMomentDate(otherDate)){
          message = i18n.invalid_date_range
          validToError = true
          validFromError = false
      } 
      if (this.state.date.from !== '' && !this.getMomentDate(this.state.date.to, true).isValid()) {
        message = i18n.invalid_to_date
        validToError = true
        validFromError = false
      }
      if (
        (selectedDate !== '' || this.state.date.to !== '') && !this.getMomentDate(selectedDate, true).isValid()
      ) {
        message = i18n.invalid_from_date
        validToError = false
        validFromError = true
      }
    }

    if (dateType === 'to') {
      if (preventFutureDates && selectedDate !== '' && this.getMomentDate(selectedDate).isAfter(moment())) {
        message = i18n.invalid_to_future_date
        validToError = true
        validFromError = false
      }
      if (preventFutureDates && this.getMomentDate(selectedDate).isAfter(moment())) {
        message = i18n.invalid_to_future_date
        validToError = true
        validFromError = false
      }
      if (
        (this.state.date.from === '' && selectedDate !== '') ||
        this.getMomentDate(this.state.date.from) > this.getMomentDate(selectedDate)
      ) {
        message = i18n.invalid_date_range
        validFromError = true
        validToError = false
      }

      if (this.state.date.from !== '' && selectedDate !== '' &&
        !this.getMomentDate(this.state.date.from, true).isValid()
      ) {
        message = i18n.invalid_from_date
        validFromError = true
        validToError = false
      }

      if ((this.state.date.from !== '' || selectedDate !== '') &&
        !this.getMomentDate(selectedDate, true).isValid()
      ) {
        message = i18n.invalid_to_date
        validToError = true
        validFromError = false
      }
    }

    return {
      validToError,
      validFromError,
      message
    }
  }

  render() {
    const {
      date,
      dateType,
      fromDateClicked,
      fromShow,
      toShow,
      errors,
      validFromError,
      validToError
    } = this.state

    const {
      dateFormat,
      datePickerFromName,
      datePickerToName,
      fromPlaceholder,
      i18n,
      label,
      locale,
      optionalDescription,
      todayLink,
      toPlaceholder,
      preventFutureDates
    } = this.props

    const calendarDate = date[dateType]
      ? moment(
        date[dateType],
        this.props.dateFormat
          ? this.props.dateFormat.toUpperCase()
          : 'DD/MM/YYYY',
        true
      ).isValid()
        ? date[dateType]
        : moment().format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')
      : moment().format(dateFormat ? dateFormat.toUpperCase() : 'DD/MM/YYYY')

    return (
      <DateRangeWrapper innerRef={this.onRefWrapper}>
        {label && <DateRangeLabel>{label}</DateRangeLabel>}

        {optionalDescription && (
          <DateRangeDescription>{optionalDescription}</DateRangeDescription>
        )}

        <DateRangeOuter
          hideMarginTop={true}
          errorState={validFromError}
          active={fromShow}
          data-testid='dateRangeFrom'
        >
          <input
            name={datePickerFromName || 'datePickerFromName'}
            type='text'
            autoComplete='off'
            data-id='from'
            onChange={this.setFromValue}
            onBlur={this.validateFromEntry}
            onKeyDown={this.handleFromKeyDown}
            value={date.from}
            placeholder={fromPlaceholder || 'From'}
          />
          <div data-testid='dateRangeShowFromCalendar' onClick={this.fromShow}>
            <Icon type='calendar' baseColor={'#afafaf'} />
          </div>
        </DateRangeOuter>
        {errors &&
          validFromError && <ErrorDivWrapper>{errors.message}</ErrorDivWrapper>}
        {fromShow && (
          <Breakout trackElement={this.wrapperEl} onClickOutside={this.close} resize={false}>
            <DateRangeCalendar
              fromDateClicked={fromDateClicked}
              label={label}
              optionalDescription={optionalDescription}
              active={fromShow}
              style={this.positionCalendar()}
              data-testid='dateRangeFromCalendar'
            >
              <TodayLink className={'Day-inner'} onClick={this.selectToday}>
                {' '}
                {todayLink || 'Today'}{' '}
              </TodayLink>
              <Calendar
                locale={locale || 'en'}
                i18n={i18n}
                date={this.getMomentDate(calendarDate)}
                onSelect={this.onSelect}
                dayRenderer={this.dayRenderer}
                preventFutureDates={preventFutureDates}
              />
            </DateRangeCalendar>
          </Breakout>
        )}
        <DateRangeOuter
          hideMarginTop={false}
          errorState={validFromError ? false : validToError}
          active={toShow}
          data-testid='dateRangeTo'
        >
          <input
            name={datePickerToName || 'datePickerToName'}
            type='text'
            data-id='to'
            autoComplete='off'
            onChange={this.setToValue}
            onBlur={this.validateToEntry}
            onKeyDown={this.handleToKeyDown}
            value={date.to}
            placeholder={toPlaceholder || 'To'}
            ref={(input) => { this.toInput = input }}
          />
          <div data-testid='dateRangeShowToCalendar' onClick={this.toShow}>
            <Icon type='calendar' baseColor={'#afafaf'} />
          </div>
        </DateRangeOuter>

        {toShow && (
          <Breakout trackElement={this.wrapperEl} onClickOutside={this.close} resize={false}>
            <DateRangeCalendar
              fromDateClicked={fromDateClicked}
              label={label}
              optionalDescription={optionalDescription}
              active={toShow}
              style={this.positionCalendar()}
              data-testid='dateRangeToCalendar'
            >
              <TodayLink className={'Day-inner'} onClick={this.selectToday}>
                {' '}
                {todayLink || 'Today'}{' '}
              </TodayLink>
              <Calendar
                locale={locale || 'en'}
                i18n={i18n}
                date={this.getMomentDate(calendarDate)}
                onSelect={this.onSelect}
                dayRenderer={this.dayRenderer}
                preventFutureDates={preventFutureDates}
              />
            </DateRangeCalendar>
          </Breakout>
        )}
        {errors &&
          !validFromError &&
          validToError && <ErrorDivWrapper>{errors.message}</ErrorDivWrapper>}
      </DateRangeWrapper>
    )
  }
}
